import { Dropdown } from "primereact/dropdown";

const MobileWarehouseSection = ({
  warehouseOptions,
  selectedAlmacen,
  setSelectedAlmacen,
  disabled = false,
}) => {
  if (!warehouseOptions.length) return null;

  return (
    <div className="p-3 border-bottom-1 surface-border">
      <label className="block text-sm font-semibold text-gray-700 mb-1">Sucursal</label>
      <p className="text-xs text-gray-400 m-0 mb-2">Selecciona tu sucursal para revisar disponibilidad y precios.</p>
      <Dropdown
        value={selectedAlmacen}
        aria-label="Seleccionar sucursal"
        onChange={(event) => setSelectedAlmacen(event.target.value)}
        options={warehouseOptions}
        disabled={disabled}
        optionLabel={(option) => option.label}
        optionValue={(option) => option.value}
        placeholder="Selecciona una sucursal"
        className="w-full"
      />
    </div>
  );
};

export default MobileWarehouseSection;
